import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from './pages/NotFound'
import ContactInfo from './pages/ContactInfo'
import Events from './pages/Events'
import Home from './pages/Home'
import LettersOfLamentation from "./pages/LettersOfLamentation";
import Printables from "./pages/Printables";
import VoicesForPalestine from "./pages/VoicesForPalestine";
import Presentations from "./pages/Presentations";
import Layout from "./Layout";
import SinglePrintablePage from "./pages/SinglePrintablePage";

const AppRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="home" element={<Home />} />
                    <Route path="voices_for_palestine" element={<VoicesForPalestine />} />
                    <Route path="events" element={<Events />} />
                    <Route path="letters_of_lamentation" element={<LettersOfLamentation />} />
                    <Route path="presentations" element={<Presentations />} />
                    <Route path="printables"  >
                        <Route index element={<Printables />} />
                        <Route path=":id" element={<SinglePrintablePage />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                    <Route path="contact_info" element={<ContactInfo />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}


export default AppRoutes;